/**
 * Moves Wishlist Plus / Swym wishlist button above the main Add to cart button.
 * This store uses Swym's legacy inject (.swym-button-bar), not the newer
 * #swym-atw-button-container PDP embed.
 */
(() => {
  const MAIN_PRODUCT = '.cc-main-product';
  const SLOT_SELECTOR = `${MAIN_PRODUCT} [data-wishlist-slot="main"]`;

  function getSlot() {
    return document.querySelector(SLOT_SELECTOR);
  }

  function getWishlistElement() {
    const root = document.querySelector(MAIN_PRODUCT);
    if (!root) return null;

    return (
      root.querySelector('#swym-atw-button-container') ||
      root.querySelector('.swym-button-bar.swym-wishlist-button-bar') ||
      root.querySelector('.swym-btn-container.swym-inject')
    );
  }

  function reposition() {
    const wishlist = getWishlistElement();
    const slot = getSlot();
    if (!wishlist || !slot) return false;

    if (!slot.contains(wishlist)) {
      slot.appendChild(wishlist);
    }

    wishlist.classList.remove('margin-top', 'default-position');
    wishlist.classList.add('margin-bottom', 'buy_buttons_above');

    if (wishlist.dataset) {
      wishlist.dataset.position = 'buy_buttons_above';
    }

    return true;
  }

  function init() {
    if (!document.querySelector(MAIN_PRODUCT)) return;

    const tick = () => reposition();

    tick();

    const root = document.querySelector(MAIN_PRODUCT);
    const observer = new MutationObserver(tick);
    observer.observe(root, { childList: true, subtree: true });

    document.addEventListener('visitorConsentCollected', tick);
    window.addEventListener('load', tick);

    setInterval(tick, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
